import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow, TableCell, Chip, IconButton, Tooltip, Box } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const RepresentativeTableRow = ({ representative, onEdit, onDelete, onViewStats, canEdit, canDelete }) => {
    const { t } = useTranslation();
    const { _id, name, id, phoneNumber, age, doctorsCount, isActive } = representative;

    return (
        <TableRow hover>
            <TableCell>{name}</TableCell>
            <TableCell>{id}</TableCell>
            <TableCell>{phoneNumber}</TableCell>
            <TableCell>{age}</TableCell>
            <TableCell>
                <Chip label={doctorsCount} size="small" color="secondary" variant="outlined" />
            </TableCell>
            <TableCell>
                <Chip
                    label={isActive ? t('status.active') : t('status.inactive')}
                    color={isActive ? 'success' : 'error'}
                    size="small"
                />
            </TableCell>
            <TableCell align="right">
                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                    <Tooltip title={t('common.viewStats')}>
                        <IconButton size="small" onClick={() => onViewStats(representative)} color="info">
                            <TrendingUpIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    {canEdit && (
                        <Tooltip title={t('common.edit')}>
                            <IconButton size="small" onClick={() => onEdit(representative)} color="primary">
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {canDelete && (
                        <Tooltip title={t('common.delete')}>
                            <IconButton size="small" onClick={() => onDelete(_id)} color="error">
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default RepresentativeTableRow;